import TagsService from '../../../modules/tags/tagsService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'TAGS_FORM'

const tagsFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tagsFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await TagsService.find(id)
      }

      dispatch({
        type: tagsFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: tagsFormActions.INIT_ERROR,
      })

      dispatch(push('/tags'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: tagsFormActions.CREATE_STARTED,
      })

      await TagsService.create(values)

      dispatch({
        type: tagsFormActions.CREATE_SUCCESS,
      })

      Message.success(i18n('entities.tags.create.success'))

      dispatch(push('/tags'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: tagsFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: tagsFormActions.UPDATE_STARTED,
      })

      await TagsService.update(id, values)

      dispatch({
        type: tagsFormActions.UPDATE_SUCCESS,
      })

      Message.success(i18n('entities.tags.update.success'))

      dispatch(push('/tags'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: tagsFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default tagsFormActions
